module.exports = __webpack_public_path__ + "static/media/ebs.ae7238d3.svg";